// extracted by mini-css-extract-plugin
export default {"root":"online-payment-module__root--CRlp1","message":"online-payment-module__message--dtGMx"};